import { render } from "./FeladatDetails.vue?vue&type=template&id=3443f2cc&scoped=true"
import script from "./FeladatDetails.vue?vue&type=script&lang=js"
export * from "./FeladatDetails.vue?vue&type=script&lang=js"

import "./FeladatDetails.vue?vue&type=style&index=0&id=3443f2cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3443f2cc"]])

export default __exports__